import { useGetMerchantGroup, useListMerchantGroups, useListMemberGroupCards } from '@/generated/hooks';
import type { ListMemberGroupCardsParamsType, ListMerchantGroupsParamsType } from '@zlinkx/shared-v2';

export function useMerchantGroups(
  merchantId: ListMerchantGroupsParamsType['merchantId'],
  enabled = true,
) {
  const query = useListMerchantGroups(
    { merchantId },
    { enabled: enabled && merchantId > 0 },
  );

  return {
    groups: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useMerchantGroupDetail(
  merchantId: number,
  cardId: string | null,
  enabled = true,
) {
  const query = useGetMerchantGroup(
    { merchantId, cardId: cardId ?? '' },
    { enabled: enabled && merchantId > 0 && cardId !== null },
  );

  return {
    group: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useMemberGroupCards(
  merchantId: ListMemberGroupCardsParamsType['merchantId'],
  userId: string | null,
  enabled = true,
) {
  const query = useListMemberGroupCards(
    { merchantId, userId: userId ?? '' },
    { enabled: enabled && merchantId > 0 && userId !== null },
  );

  return {
    groups: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
